import { useEffect, useRef, useState } from "react";

const inputClassName =
  "mb-auto appearance-none block bg-grey-lighter text-grey-darker border border-stone-200 rounded py-1 px-3 shadow-sm";

const byType = {
  text: inputClassName,
  password: inputClassName,
  search: inputClassName,
  email: inputClassName,
  number: inputClassName,
  textarea: inputClassName,
  date: inputClassName,
  "datetime-local": inputClassName,
  time: inputClassName,
  checkbox: "my-auto",
};

const Input = ({ type, value, ref: parentRef, ...props }) => {
  const localRef = useRef(null);
  const [val, setVal] = useState(value);
  const ref = parentRef || localRef;

  const valRef = useRef();
  valRef.current = val;
  useEffect(() => {
    if (valRef.current === value) return;
    setVal(value);
  }, [value]);

  useEffect(() => {
    if (props.focus) {
      ref.current.focus();
      ref.current.selectionStart = ref.current.value.length;
    }
  }, [props.focus, props.focusMoveEnd, ref]);

  let { className } = props;
  className =
    className instanceof Array
      ? className
          .flat(Infinity)
          .filter((item) => item)
          .join(" ")
      : className;

  type = type || "text";
  if (!className && ["text", "password"].includes(type)) className = "sm:w-1/2 w-full";

  const elementProps = {
    ...props,
    ref,
    onChange: (e) => {
      setVal(e.target.value);
      props.onChange(e.target.value);
    },
    onFocus: (ev) => {
      if (props.selectAllOnFocus) ref.current.select();
      if (props.onFocus) return props.onFocus(ev);
    },
    className: `${byType[type]} ${className}`,
    type,
    value: val,
    focus: undefined,
    renderAs: undefined,
    accessibilityLabel: undefined,
    accessible: undefined,
    translate: undefined,
    accessibilityTraits: undefined,
    selectAllOnFocus: undefined,
  };

  Object.keys(elementProps)
    .filter((key) => elementProps[key] === undefined)
    .forEach((key) => {
      delete elementProps[key];
    });

  return type === "textarea" ? <textarea {...elementProps} /> : <input {...elementProps} />;
};

export default Input;
